<template>
  <section class="app-main">
    <transition name="fade" mode="out-in">
      <!-- <router-view :key="key"></router-view> -->
      <!-- <keep-alive>
        <router-view></router-view>
      </keep-alive> -->

      <router-view  />
  <!-- <keep-alive><router-view :key="$route.path"></router-view></keep-alive> -->


    </transition>
  </section>
</template>

<script>
export default {
  name: 'AppMain',
  computed: {
    key() {
      return this.$route.fullPath;
      // return this.$route.name !== undefined ? this.$route.name + +new Date() : this.$route + +new Date()
    }
  },
  created () {
    //console.log(this.$route.meta.keepAlive)
  }
}
</script>



// WEBPACK FOOTER //
// src/views/layout/components/AppMain.vue